import { FORM_ELEMENT_ADDRESS } from 'constants/FormConstants';

export const ROLES = ['Manager', 'Terminal'];

export const TABLE_ELEMENT_PICKED_UD_AT = 'pickedUpAt';

export const DISABLE_SORTING_PLACE_COLUMNS = {
  columns: [FORM_ELEMENT_ADDRESS],
};
